// Renders **marked** words in the serif italic used for heading emphasis.
//
// Headings used to be two fields — the plain part and the italic part — which
// meant the italic could only ever be the trailing words. One string with
// markers lets any words be emphasised, anywhere, in any number.
//
//   "Recent **adventures**"      → Recent <em>adventures</em>
//   "**All** of my **work**"     → <em>All</em> of my <em>work</em>

const MARKED = /(\*\*[^*]+\*\*)/g;

function Emphasis({ children }) {
  if (!children) return null;

  const parts = String(children).split(MARKED);

  return (
    <>
      {parts.map((part, i) =>
        part.startsWith("**") && part.endsWith("**") ? (
          <span key={i} className="font-serif italic font-normal">
            {part.slice(2, -2)}
          </span>
        ) : (
          part
        )
      )}
    </>
  );
}

// For places that need the words without the markup — the browser tab title,
// the sitemap, anywhere a string is required rather than JSX.
export const stripEmphasis = (text) => String(text ?? "").replace(/\*\*/g, "");

export default Emphasis;
